import toast from 'react-hot-toast';

export const MAX_MODERATION_ATTEMPTS = 3;

/**
 * Show the right feedback after a job save, based on the moderation state the
 * server wrote onto the saved job. Shared by every job form so the message is
 * identical everywhere.
 *
 * Returns true when the posting was flagged (caller may keep the modal open).
 */
export const showModerationFeedback = (savedJob, { isEdit = false } = {}) => {
  if (!savedJob) return false;
  const flags = Array.isArray(savedJob.moderationFlags) ? savedJob.moderationFlags : [];
  const attempts = Number(savedJob.moderationAttempts || 0);

  if (savedJob.moderationStatus === 'flagged') {
    const issues = flags.slice(0, 4).map(f => `• ${f.category}: "${f.matchedPhrase}"`).join('\n')
      + (flags.length > 4 ? `\n• …and ${flags.length - 4} more` : '');
    if (savedJob.moderationLocked) {
      toast.error(
        `Posting LOCKED after ${MAX_MODERATION_ATTEMPTS} failed moderation attempts.\nIt is hidden from students and can no longer be edited — delete it and post a fresh listing.\n\n${issues}`,
        { duration: 12000, style: { maxWidth: 520, whiteSpace: 'pre-line' } }
      );
    } else {
      const remaining = Math.max(0, MAX_MODERATION_ATTEMPTS - attempts);
      toast(
        `Posting flagged — attempt ${attempts} of ${MAX_MODERATION_ATTEMPTS}.\nHidden from students until fixed. ${remaining} attempt${remaining === 1 ? '' : 's'} left before it locks.\n\n${issues}`,
        { icon: '⚠️', duration: 12000, style: { maxWidth: 520, whiteSpace: 'pre-line', background: '#fffbeb', color: '#78350f', border: '1px solid #fcd34d' } }
      );
    }
    return true;
  }

  toast.success(isEdit ? 'Job posting updated — visible to students.' : 'Job posting created — visible to students.');
  return false;
};

/** Friendly message for a 403 returned when editing a locked posting. */
export const lockedEditMessage = (error) =>
  error?.response?.data?.moderationLocked
    ? error.response.data.message
    : null;
